// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yk8S","colBig":"styles_colBig__3SYR6","colSmall":"styles_colSmall__WRUV6"};